module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"fileNotFoundTitle":"Fichier indisponible","fileNotFoundMessage":"Le fichier demandé n\u0027est plus disponible","goToHome":"Revenir à l\u0027accueil"},"en":{"fileNotFoundTitle":"File not found","fileNotFoundMessage":"The requested file is not available anymore","goToHome":"Go to the homepage"}}')
  delete Component.options._Ctor
}
